// the given set images
import TheGivenSetCommunicationDomain from '../../assets/Posters/The Given Set/The Given Set Communication Domain.jpg'
import TheGivenSetTheoryDomainB from '../../assets/Posters/The Given Set/The Given set theory domain B.jpg'
// The Error Correction
import TheErrorCorrectionFunction from '../../assets/Posters/The Error Correction Function/The Error Correction Function.png'
import ErrorCorrectionCommunicationDomainA from '../../assets/Posters/The Error Correction Function/Error Correction Communication Domain_A.jpg'
// The Given Set Stability
import GivenStabilityPerson1Person2 from '../../assets/Posters/The Given Set Stability/Given Stability Person 1 Person 2.jpg';
import GivenSetStabilityonTopandBelow from '../../assets/Posters/The Given Set Stability/Given Set Stability on Top and Below.jpg';
import GivenSetStabilityMeYouWe from '../../assets/Posters/The Given Set Stability/Given Set Stability Me You We.jpg';
import GivenSetStabilityMeYouWeBelow from '../../assets/Posters/The Given Set Stability/Given Set Stability Me You We Below.jpg';
import GivenSetStablityPrincipleFlowPerson1Person2 from '../../assets/Posters/The Given Set Stability/Given Set Stablity Principle Flow Person 1 Person 2.jpg';
import GivenSetStabilityonTopBelowPrincipleFlow from '../../assets/Posters/The Given Set Stability/Given Set Stability on Top Below Principle Flow.jpg';
import GivenSetStabilityPrincipleFlowFromToptoBelowMeYou from '../../assets/Posters/The Given Set Stability/Given Set Stability Principle Flow from Top to Below Me You.jpg';
import GivenSetStabilityPrincipleFlowMeYou from '../../assets/Posters/The Given Set Stability/Given Set Stability Principle Flow Me You.jpg';


// Problem Identification and Solution
import ProblemSolutionsCommunicationDomain from '../../assets/Posters/Problem Identification and Solution/Problem & Solutions Communication Domain_ B.jpg'
import ProblemSolutionsTheoryDomainB from '../../assets/Posters/Problem Identification and Solution/Problem & Solutions Theory Domain B.jpg'

// The Given Solution
import SolutionProcessWorkinginGroup1 from '../../assets/Posters/The Given Solution/Solution Process Working in Group 1.jpg'
import SolutionProcessWorkinginGroupMath from '../../assets/Posters/The Given Solution/Solution Process Working in Group Math 1.jpg'
import TheGivenSolutionApplication from '../../assets/Posters/The Given Solution/the given solution application.png'
import TheGivenSolutionApplicationIdea from '../../assets/Posters/The Given Solution/the given solution application idea.png'
import TheGivenSolutionList from '../../assets/Posters/The Given Solution/the given solution list.png'


// contry map
import USAasFunctonMainLand from '../../assets/Posters/Country Map/USA as functon main land.png'
import USAasFunctionMainLandPositiveAndNegative from '../../assets/Posters/Country Map/USA as function main land positive and negative.png'
import USAasFunctionPeopleAndFunction from '../../assets/Posters/Country Map/USA as function people and function.png'
import USAasFunctionPeopleAndFunctionPositiveAndNegative from '../../assets/Posters/Country Map/USA as function people and function positive and negative.png'
import USAasFunctionAlaskaNaHawaii from '../../assets/Posters/Country Map/USA as function alaska na hawaii.png'
import USAasFunctionAlaskaHawaiiPositiveAndNegative from '../../assets/Posters/Country Map/USA as function alaska hawaii positive and negative.png'
import USAasFunctionAlaskaAndHawaiiWithPeople from '../../assets/Posters/Country Map/USA as function alaska and hawaii with people.png'
import USAasFunctionWithPeopleAlaskaAndHawaitPositiveAndNegative from '../../assets/Posters/Country Map/USA as function with people alaska and hawait positive and negative.png'
import USAasHouse from '../../assets/Posters/Country Map/USA as house.png'
import USAasBoatOfFunction from '../../assets/Posters/Country Map/USA as boat of function.png'
import USAAsboatOfFunctionPositiveAndNegative from '../../assets/Posters/Country Map/USA as boat of function positive and negative.png'
import USAasBoatOfFunctionWithPeople from '../../assets/Posters/Country Map/USA as boat of function with people.png'
import USAasBoatOfFunctionWithPeoplePositiveAndNegative from '../../assets/Posters/Country Map/USA as boat of function with people positive and negative.png'




import React, { useState, useEffect } from 'react'
import './poster.css'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import PagesTitle from '../../widgets/pages_title/pages_title';
import AppBarWidget from '../../widgets/app_bar/app_bar';
import PosterWizard from './poster_wizard/poster_wizard';
import PosterPreview from './poster_preview';
import { createPosterAPI, getPostersAPI, deletePosterAPI } from '../../api/poster';
import { showAlert } from '../../functions/show_alert';
import { showProgressAlert, HideProgressAlert } from '../../functions/show_progress_page';
const type = {
    theGivenSet: 'The Given Set',
    theErrorCorrection: 'Error Correction',
    theGivenSetStability: 'The Given Set Stability',
    problem: 'Problem Identification and Solution',
    solution: 'The Given Solution',
    contry: 'Country Map',
    none: 'none',
}
export default function PosterScreen() {

    const [posterType, SetPosterType] = useState(type.none);
    const [showThisPoster, SetShowThisPoster] = useState(null);
    const [showCreatePosterWizard, SetShowCreatePosterWizard] = useState(false);
    const [savedPosters, setSavedPosters] = useState([]);
    const [loadingPosters, setLoadingPosters] = useState(false);
    const [selectedPoster, setSelectedPoster] = useState(null);

    // Fetch saved posters
    const fetchPosters = async () => {
        setLoadingPosters(true);
        try {
            const response = await getPostersAPI();
            if (response.statusCode === 200 && response.response) {
                // Combine all poster types
                const allPosters = [
                    ...(response.response.given_set || []),
                    ...(response.response.country || []),
                    ...(response.response.error || [])
                ];
                setSavedPosters(allPosters);
            }
        } catch (error) {
            console.error('Error fetching posters:', error);
        } finally {
            setLoadingPosters(false);
        }
    };

    // Fetch posters when component mounts or posterType changes
    useEffect(() => {
        if (posterType !== type.none) {
            fetchPosters();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [posterType]);

    // Filter saved posters by current poster type
    const getFilteredSavedPosters = () => {
        if (posterType === type.none) return [];
        return savedPosters.filter(poster => {
            // Match poster type with selected type
            // Special case: "Show Actual Principle" and "Show Derived Principle" should be shown under "The Given Set"
            if (posterType === type.theGivenSet) {
                return poster.type === 'The Given Set' ||
                    poster.type === 'Show Actual Principle' ||
                    poster.type === 'Show Derived Principle';
            }
            return poster.type === posterType;
        });
    };

    // Handle poster deletion
    const handleDeletePoster = async (posterId, e) => {
        e.stopPropagation(); // Prevent opening the preview modal

        // Show confirmation
        if (window.confirm('Are you sure you want to delete this poster?')) {
            showProgressAlert();
            try {
                const response = await deletePosterAPI(posterId);
                HideProgressAlert();

                if (response.statusCode === 200) {
                    showAlert(true, 'Poster deleted successfully');
                    // Refresh the poster list
                    fetchPosters();
                } else {
                    showAlert(false, response.response?.message || 'Failed to delete poster');
                }
            } catch (error) {
                HideProgressAlert();
                showAlert(false, 'An error occurred while deleting the poster');
            }
        }
    };

    const images = {
        'The Given Set': [
            {
                'name': "The Given Set Communication Domain",
                'image': TheGivenSetCommunicationDomain
            },
            {
                'name': "The Given set theory domain",
                'image': TheGivenSetTheoryDomainB,
            },
        ],
        'Error Correction': [
            {
                'name': "The Error Correction Function",
                'image': TheErrorCorrectionFunction,
            },
            {
                'name': "Error Correction Communication Domain",
                'image': ErrorCorrectionCommunicationDomainA,
            },
        ],
        'The Given Set Stability': [
            {
                'name': "Given Stability Person 1 Person 2",
                'image': GivenStabilityPerson1Person2,
            },
            {
                'name': "Given Set Stability on Top and Below",
                'image': GivenSetStabilityonTopandBelow,
            },
            {
                'name': "Given Set Stability Me You We",
                'image': GivenSetStabilityMeYouWe,
            },
            {
                'name': "Given Set Stability Me You We Below",
                'image': GivenSetStabilityMeYouWeBelow,
            },
            {
                'name': "Given Set Stablity Principle Flow Person 1 Person 2",
                'image': GivenSetStablityPrincipleFlowPerson1Person2,
            },
            {
                'name': "Given Set Stability on Top Below Principle Flow",
                'image': GivenSetStabilityonTopBelowPrincipleFlow,
            },
            {
                'name': " Given Set Stability Principle Flow from Top to Below Me You",
                'image': GivenSetStabilityPrincipleFlowFromToptoBelowMeYou,
            },
            {
                'name': "Given Set Stability Principle Flow Me You",
                'image': GivenSetStabilityPrincipleFlowMeYou,
            },
        ],
        'Problem Identification and Solution': [
            {
                'name': "Problem & Solutions Communication Domain",
                'image': ProblemSolutionsCommunicationDomain,
            },
            {
                'name': "Problem & Solutions Theory Domain",
                'image': ProblemSolutionsTheoryDomainB,
            },

        ],
        'The Given Solution': [
            {
                'name': "Solution Process Working in Group 1",
                'image': SolutionProcessWorkinginGroup1,
            },
            {
                'name': "Solution Process Working in Group Math 1",
                'image': SolutionProcessWorkinginGroupMath,
            },
            {
                'name': "The Given Solution Application",
                'image': TheGivenSolutionApplication,
            },
            {
                'name': "The Given Solution Application Idea",
                'image': TheGivenSolutionApplicationIdea,
            },
            {
                'name': "The Given Solution List",
                'image': TheGivenSolutionList,
            },
        ],
        'Country Map': [
            {
                'name': "USA as functon main land",
                'image': USAasFunctonMainLand
            },
            {
                'name': "USA as function main land positive and negative",
                'image': USAasFunctionMainLandPositiveAndNegative
            },
            {
                'name': "USA as function people and function",
                'image': USAasFunctionPeopleAndFunction
            },
            {
                'name': "USA as function people and function positive and negative",
                'image': USAasFunctionPeopleAndFunctionPositiveAndNegative
            },
            {
                'name': "USA as function alaska na hawaii",
                'image': USAasFunctionAlaskaNaHawaii
            },
            {
                'name': "USA as function alaska hawaii positive and negative",
                'image': USAasFunctionAlaskaHawaiiPositiveAndNegative
            },
            {
                'name': "USA as function alaska and hawaii with people",
                'image': USAasFunctionAlaskaAndHawaiiWithPeople,
            },
            {
                'name': "USA as function with people alaska and hawait positive and negative",
                'image': USAasFunctionWithPeopleAlaskaAndHawaitPositiveAndNegative,
            },
            {
                'name': "USA as house",
                'image': USAasHouse,
            },
            {
                'name': "USA as boat of function",
                'image': USAasBoatOfFunction,
            },
            {
                'name': "USA as boat of function positive and negative",
                'image': USAAsboatOfFunctionPositiveAndNegative,
            },
            {
                'name': "USA as boat of function with people",
                'image': USAasBoatOfFunctionWithPeople,
            },
            {
                'name': "USA as boat of function with people positive and negative",
                'image': USAasBoatOfFunctionWithPeoplePositiveAndNegative,
            },
        ],

    }

    // If preview is showing, render only the preview screen
    if (selectedPoster) {
        return (
            <PosterPreviewScreen
                poster={selectedPoster}
                onClose={() => setSelectedPoster(null)}
            />
        );
    }

    // If wizard is showing, render only the wizard
    if (showCreatePosterWizard) {
        return (
            <PosterWizard
                posterType={posterType}
                onClose={() => SetShowCreatePosterWizard(false)}
                onComplete={async (data) => {
                    // Check payload size before sending
                    const payloadString = JSON.stringify(data);
                    const payloadSizeMB = new Blob([payloadString]).size / (1024 * 1024);

                    // Warn if payload is too large (typically server limit is around 1-2MB)
                    if (payloadSizeMB > 1.5) {
                        const shouldContinue = window.confirm(
                            `The poster data is quite large (${payloadSizeMB.toFixed(2)}MB). This might cause upload issues. ` +
                            `Consider using smaller images. Do you want to continue?`
                        );
                        if (!shouldContinue) {
                            return;
                        }
                    }

                    // Handle poster creation completion
                    showProgressAlert();
                    try {
                        const response = await createPosterAPI(data);
                        HideProgressAlert();

                        if (response.statusCode === 200) {
                            showAlert(true, 'Poster created successfully');
                            SetShowCreatePosterWizard(false);
                            // Refresh the poster list
                            fetchPosters();
                        } else {
                            showAlert(false, response.response || 'Failed to create poster');
                        }
                    } catch (error) {
                        HideProgressAlert();
                        if (error.message && error.message.includes('413')) {
                            showAlert(false, 'Request too large. Please use smaller images or reduce the number of images.');
                        } else {
                            showAlert(false, 'An error occurred while creating the poster');
                        }
                    }
                }}
            />
        );
    }

    return (
        <>
            <AppBarWidget />
            <div id='poster'>
                <div className="title-holder">
                    <PagesTitle title={`${posterType !== type.none ? 'Poster ' + posterType : 'Poster Category'}`} />
                </div>
                {posterType !== type.none ? <div onClick={() => SetPosterType(type.none)} className='back-button'><ArrowBackIosIcon /> BACK</div> : <></>}
                {
                    posterType === type.none ?
                        <div className='types-holder'>
                            <div onClick={() => SetPosterType(type.theGivenSet)} className='main-box-holder'>
                                <div className="type-box"><img src={TheGivenSetCommunicationDomain} alt="" /></div>
                                <h1 className='box-type'>The Given Set</h1>
                            </div>
                            <div onClick={() => SetPosterType(type.theErrorCorrection)} className='main-box-holder'>
                                <div className="type-box"><img src={TheErrorCorrectionFunction} alt="" /></div>
                                <h1 className='box-type'>Error Correction</h1>
                            </div>
                            <div onClick={() => SetPosterType(type.theGivenSetStability)} className='main-box-holder'>
                                <div className="type-box"><img src={GivenStabilityPerson1Person2} alt="" /></div>
                                <h1 className='box-type'>The Given Set Stability</h1>
                            </div>
                            <div onClick={() => SetPosterType(type.solution)} className='main-box-holder'>
                                <div className="type-box"><img src={SolutionProcessWorkinginGroup1} alt="" /></div>
                                <h1 className='box-type'>The Given Solution</h1>
                            </div>
                            <div onClick={() => SetPosterType(type.problem)} className='main-box-holder'>
                                <div className="type-box"><img src={ProblemSolutionsCommunicationDomain} alt="" /></div>
                                <h1 className='box-type'>Problem Identification and Solution</h1>
                            </div>
                            <div onClick={() => SetPosterType(type.contry)} className='main-box-holder'>
                                <div className="type-box"><img src={USAasFunctonMainLand} alt="" /></div>
                                <h1 className='box-type'>Country Map</h1>
                            </div>
                            {/* <div onClick={() => SetPosterType(type.none)} className="type-box flex">
                                <AddCircleIcon className='add-poster' />
                                <h1 className='create-poster'>Create Poster</h1>
                            </div> */}
                        </div>
                        :
                        <div className="posters">
                            {/* Loading state */}
                            {loadingPosters && (
                                <div className="posters-loading">
                                    <p>Loading posters...</p>
                                </div>
                            )}
                            {/* Display saved posters first */}
                            {!loadingPosters && getFilteredSavedPosters().map((poster) => {
                                // Generate poster name from data
                                let posterName = `Poster ${poster.id}`;
                                if (poster.type === 'Country Map') {
                                    posterName = poster.person_name || poster.business_name || 'Country Map';
                                } else if (poster.images && poster.images.length > 0 && poster.images[0].name) {
                                    posterName = poster.images[0].name;
                                } else if (poster.selected_principle) {
                                    posterName = poster.selected_principle;
                                } else if (poster.type) {
                                    posterName = poster.type;
                                }

                                // Transform poster data to match preview component format
                                let posterData = { ...poster };

                                // Handle Country Map type
                                if (poster.type === 'Country Map') {
                                    posterData.countryData = {
                                        selectedCountry: poster.country || 'usa_mainland'
                                    };
                                    posterData.detailsData = {
                                        personName: poster.person_name || '',
                                        businessName: poster.business_name || '',
                                        personFunction: poster.person_function || '',
                                        functionAtLocation: poster.function_at_location || '',
                                        personImage: poster.person_image_path || null,
                                        personImageFileName: null,
                                        functionImage: poster.function_image_path || null,
                                        functionImageFileName: null,
                                    };
                                    posterData.preferencesData = {
                                        selectedPreferences: [
                                            ...(poster.execution_in_given_set ? ['show_function_execution_given_set'] : []),
                                            ...(poster.execution_in_green ? ['show_function_execution_green'] : [])
                                        ]
                                    };
                                } else if (poster.type === 'Error Correction') {
                                    // Transform feedback source and target data
                                    const feedbackSourceData = poster.feedback_source_data || {};
                                    const feedbackTargetData = poster.feedback_target_data || {};

                                    // Find images for feedback source and target
                                    const sourceImage = poster.images?.find(img => img.name === 'Feedback Source');
                                    const targetImage = poster.images?.find(img => img.name === 'Feedback Target');

                                    posterData.feedbackSourceData = {
                                        text: feedbackSourceData.text || '',
                                        image: sourceImage?.image_path || feedbackSourceData.image_path || null,
                                        fileName: feedbackSourceData.fileName || sourceImage?.title || null,
                                    };

                                    posterData.feedbackTargetData = {
                                        text: feedbackTargetData.text || '',
                                        image: targetImage?.image_path || feedbackTargetData.image_path || null,
                                        fileName: feedbackTargetData.fileName || targetImage?.title || null,
                                    };
                                } else {
                                    // The API stores people data in the 'people' JSON field and images separately
                                    let peopleData = [];

                                    if (poster.people && Array.isArray(poster.people) && poster.people.length > 0) {
                                        // Use people data from the people field
                                        peopleData = poster.people.map((person, idx) => {
                                            // Try to match with images array by index
                                            const matchedImage = poster.images && poster.images[idx] ? poster.images[idx] : null;
                                            return {
                                                name: person.name || matchedImage?.name || `Person ${idx + 1}`,
                                                image: matchedImage?.image_path || person.image || null,
                                                image_path: matchedImage?.image_path || person.image_path || null,
                                                fileName: person.fileName || matchedImage?.title || '',
                                            };
                                        });
                                    } else if (poster.images && Array.isArray(poster.images) && poster.images.length > 0) {
                                        // Fallback: use images array if people array is empty
                                        peopleData = poster.images.map((img, idx) => ({
                                            name: img.name || `Person ${idx + 1}`,
                                            image: img.image_path,
                                            image_path: img.image_path,
                                            fileName: img.title || '',
                                        }));
                                    }

                                    posterData.people = peopleData;
                                }

                                return (
                                    <div key={poster.id} className="poster-element">
                                        <div className="poster-card-wrapper">
                                            <PosterPreview
                                                poster={posterData}
                                                isCompact={true}
                                                onClick={() => setSelectedPoster(posterData)}
                                            />
                                            <DeleteIcon
                                                className="poster-delete-icon"
                                                onClick={(e) => handleDeletePoster(poster.id, e)}
                                            />
                                        </div>
                                        <div className="proster-element-name">{posterName}</div>
                                    </div>
                                );
                            })}
                            {/* Display static images */}
                            {images[posterType].map((e, index) => (
                                <PosterElement
                                    key={`static-${index}`}
                                    SetShowThisPoster={SetShowThisPoster}
                                    urlLink={e.image}
                                    name={e.name}
                                />
                            ))}
                            {/* Create Poster button */}
                            <div onClick={() => SetShowCreatePosterWizard(true)} className="create-poster-grid-view">
                                <div className="create-poster-icon-wrapper">
                                    <AddIcon className="create-poster-icon" />
                                </div>
                                <div className="create-poster-text">Create Poster</div>
                            </div>
                        </div>
                }
                {showThisPoster === null ? <></> : <div onClick={() => SetShowThisPoster(null)} className="poster-big">
                    <img src={showThisPoster} alt=" " />
                </div>}
            </div>
        </>

    )
}

// Poster Preview Screen Component (Full-screen like project wizard)
const PosterPreviewScreen = ({ poster, onClose }) => {
    return (
        <>
            <AppBarWidget />
            <div className="poster-preview-screen">
                <div className="poster-preview-container">
                    <div className="poster-preview-header">
                        <h1 className="poster-preview-title">Poster Preview</h1>
                    </div>
                    <div className="poster-preview-content">
                        <PosterPreview poster={poster} isCompact={false} />
                    </div>
                    <div className="poster-preview-footer">
                        <button className="poster-preview-button close" onClick={onClose}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

const PosterElement = ({ urlLink, name, SetShowThisPoster }) => {
    return <div onClick={() => SetShowThisPoster(urlLink)} className="poster-element">
        <img alt=" " src={urlLink} className="poster-image"></img>
        <div className="proster-element-name">{name}</div>
    </div>
}


